import React, { useState } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
import { isEmpty, isFunction } from 'lodash';
import PropTypes from 'prop-types';
import { Spinner } from '~/components';

import { t } from '~/helpers';


export default function ConfirmationDialogRaw({
  valueProp,
  open,
  mensagem,
  titulo,
  textoBtnOK,
  textoBtnCancel,
  onClose,
  modal,
}) {
  //const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = React.useState(valueProp);
  const radioGroupRef = React.useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  React.useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handleCancel = () => {
    try {
      setIsLoading(true);
      onClose();
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }

  };

  const handleOk = () => {
    try {
      setIsLoading(true);
      onClose(value);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };
  //const isSelected = (name) => selected.indexOf(name) !== -1;
  return (
    <div>
      {isLoading ? (
        <div style={{ zIndex: 999999 }}>
          <Spinner loading />
        </div>
      ) : (
        ''
      )}

      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth={modal}
        onEntering={handleEntering}
        aria-labelledby="confirmation-dialog-title"
        open={open}
      //{...other}
      >
        {/* <DialogTitle id="confirmation-dialog-title">Confirmar</DialogTitle> */}
        <DialogTitle id="confirmation-dialog-title">{titulo}</DialogTitle>
        <DialogContent dividers>
          <span>{mensagem}</span>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCancel} color="primary"> {textoBtnCancel} </Button>
          <Button onClick={handleOk} color="primary"> {textoBtnOK} </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}


ConfirmationDialogRaw.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  valueProp: PropTypes.string.isRequired,
  mensagem: PropTypes.string.isRequired,
  titulo: PropTypes.string.isRequired,
  textoBtnOK: PropTypes.string.isRequired,
  textoBtnCancel: PropTypes.string.isRequired,
  modal: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs']),

};

ConfirmationDialogRaw.defaultProps = {
  valueProp: '',
  open: false,
  mensagem: '',
  titulo: 'CONFIRMAR',
  textoBtnOK: 'Ok',
  textoBtnCancel: 'Cancel',
  modal: 'xs',
};
